import { Grid } from '@mui/material';

import SearchBox from '../components/SearchBox';
import Button from '../components/Button';
import Filter from '../components/filter';
import SmallIcon from '../components/smallIcon';

const renderControl = (component, disabled, index) => {
  switch (component.name) {
    case 'SearchBox':
      return <SearchBox key={index} {...component.props} disabled={disabled} />;
    case 'Button':
      return <Button key={index} {...component.props} disabled={disabled || component.props.disabled} />;
    case 'IconButton':
      return <SmallIcon key={index} {...component.props} disabled={disabled || component.props.disabled} />;
    case 'Filter':
      return <Filter key={index} {...component.props} disabled={disabled || component.props.disabled} />;
    default:
      return <></>;
  }
};

export const ActionPanelControlsReducer = (components, disabled) => {
  return components.map((component, index) => (
    <Grid item key={index}>
      {renderControl(component, disabled, index)}
    </Grid>
  ));
};
